import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useQuery } from '@tanstack/react-query'
import type { Bet } from '../domain/Bet.domain'

const sortProofPoints = (pts: Bet['delivered']) =>
  [...pts].sort((a, b) => a.text.localeCompare(b.text))

export const useGetBets = () => {
  const api = useApiClient()

  return useQuery({
    queryKey: [QueryKeys.Bets],
    queryFn: async () => {
      const response = await api.get<Bet[]>('/bets')
      return response.data.map((bet) => ({
        ...bet,
        delivered: sortProofPoints(bet.delivered),
        inProgress: sortProofPoints(bet.inProgress),
        upNext: sortProofPoints(bet.upNext),
      }))
    },
  })
}
